.picker {
  display: flex;
  flex-direction: column;
  gap: 6px;
  text-align: left;
}
.label {
  font-size: 12px;
  font-weight: 700;
  color: var(--muted);
  letter-spacing: 0.02em;
}
.picker input,
.picker select {
  border: 1px solid var(--border-strong);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 15px;
  background: #fff;
  width: 100%;
}
.picker input:focus,
.picker select:focus {
  outline: none;
  border-color: var(--blue-l);
  box-shadow: 0 0 0 3px rgba(12, 134, 188, 0.35);
}
.chosen {
  display: flex;
  align-items: baseline;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 12px;
  background: #f3fafc;
  border: 1px solid var(--border);
  border-radius: 10px;
  color: var(--ink);
}
.link {
  border: none;
  background: transparent;
  color: var(--blue-text);
  font-weight: 700;
  font-size: 13px;
  padding: 2px 4px;
  margin-left: auto;
}
.link:hover {
  text-decoration: underline;
}
.hits {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 10px;
  overflow: hidden;
  max-height: 260px;
  overflow-y: auto;
}
.hits button {
  display: block;
  width: 100%;
  text-align: left;
  border: none;
  background: #fff;
  padding: 10px 12px;
  font-size: 15px;
  color: var(--ink);
  border-bottom: 1px solid var(--border);
}
.hits li:last-child button {
  border-bottom: none;
}
.hits button:hover,
.hits button:focus-visible {
  background: #f3fafc;
}
.note {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}
